module.exports = "<button type=\"button\" class=\"btn btn-primary\" ng-click=\"openCalendar()\" ng-disabled=\"disabled\">\n  <i class=\"fa-solid fa-calendar-days\" fa-thin fa-2x></i>\n  <span ng-if=\"buttonText\">{{buttonText}}</span>\n</button>\n";


//////////////////
// WEBPACK FOOTER
// ./client/common/directives/calendar/tc-calendar.html
// module id = 524
// module chunks = 0